<template>
  <section>
    <EditDialog ref="editDialog" @sub="handleEditSub" />
    <ChooseViolation
      :otherSearchData="{
        costType: 2006,
      }"
      ref="chooseViolation"
      :customShow="true"
      @change="handleEditSub" />
    <span class="primary cur addBtn" @click="showEdit()">添加</span>
    <span class="primary cur" @click="showChoose()">选择</span>
    <!-- 表格 -->
    <section class="tableBox" v-show="resultVal.length !== 0">
      <el-table
        v-loading="tableData.loading"
        ref="multipleTable"
        :data="resultVal"
        tooltip-effect="dark"
      >
        <!-- 常规列表项 -->
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.minW"
          :width="item.w"
        />
        <!-- 常规列表项 end -->
        <!-- 操作按钮 -->
        <el-table-column prop="control" label="操作" width="160">
          <template slot-scope="scope">
            <section>
              <!-- 操作按钮 -->
              <qx-permpisions permpisions="">
                <span class="primary cur" @click="showEdit(scope.row)">修改</span>
              </qx-permpisions>
              <qx-permpisions permpisions="">
                <span class="primary cur" @click="del(scope.row)">删除</span>
              </qx-permpisions>
              <!-- 操作按钮 end -->
            </section>
          </template>
        </el-table-column>
        <!-- 操按钮 end -->
      </el-table>
    </section>
    <!-- 表格 end -->
  </section>
</template>

<script>
import EditDialog from './editDialog';
import ChooseViolation from 'components/choose/violation';
export default {
  components: {
    EditDialog,
    ChooseViolation,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'cc',
  },
  props: {
    resultVal: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      tableData: { // 表格相关数据
        title: [ // 表头
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'categoryIdName',
            label: '违章类型',
          },
          {
            prop: 'violationTime',
            label: '违章时间',
          },
          // {
          //   prop: 'locationName',
          //   label: '违章城市',
          // },
          // {
          //   prop: 'violationAddress',
          //   label: '违章地点',
          // },
          // {
          //   prop: 'violationCode',
          //   label: '违章代码',
          // },
          {
            prop: 'violationFine',
            label: '罚金（元）',
          },
          {
            prop: 'violationPoint',
            label: '扣分数',
          },
          {
            prop: 'overdueFine',
            label: '滞纳金（元）',
          },
          {
            prop: 'otherFee',
            label: '代办处理费（元）',
          },
          {
            prop: 'feeAscriptionDate',
            label: '缴费日期',
          },
          {
            prop: 'personLiable',
            label: '责任人',
          },
          {
            prop: 'payAmt',
            label: '申请金额（元）',
          },
          // {
          //   prop: 'violationReason',
          //   label: '违章行为',
          // },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    showEdit (item) {
      this.$refs.editDialog.show(item);
    },
    showChoose () {
      this.$refs.chooseViolation.show();
    },
    handleEditSub (item) {
      if (!item.form) { // 选择
        const resultValIds = this.resultVal.map((item) => item.recordId);
        item.forEach((d) => {
          if (resultValIds.indexOf(d.recordId) === -1) {
            d.violationPoint = String(d.violationPoint);
            d.busiType = d.licenceType;
            this.resultVal.push(d);
          }
          d.categoryId = String(d.categoryId);
        });
      } else if (item.originData) { // 修改
        const index = this.resultVal.indexOf(item.originData);
        this.resultVal.splice(index, 1, item.form);
      } else { // 新增
        this.resultVal.push(item.form);
      }
      this.$emit('cc', this.resultVal);
      this.$emit('change', this.resultVal);
    },
    del (item) {
      this.resultVal.splice(this.resultVal.indexOf(item), 1);
      this.$emit('cc', this.resultVal);
      this.$emit('change', this.resultVal);
    },
  },
};
</script>

<style scoped lang="scss">
.addBtn{
  margin-right: 16px;
}
</style>
